/* APP MENU */
export const INIT_MENU = 'INIT_MENU';
export const INIT_MENU_SUCCESS = 'INIT_MENU_SUCCESS';
export const CHANGE_ACTIVE_MENU_FROM_LOCATION = 'CHANGE_ACTIVE_MENU_FROM_LOCATION';
export const CHANGE_ACTIVE_MENU_FROM_LOCATION_SUCCESS = 'CHANGE_ACTIVE_MENU_FROM_LOCATION_SUCCESS';
export const FETCH_MAINTENANCE_REQUEST_BADGE = 'FETCH_MAINTENANCE_REQUEST_BADGE';
export const FETCH_MAINTENANCE_REQUEST_BADGE_SUCCESS = 'FETCH_MAINTENANCE_REQUEST_BADGE_SUCCESS';
export const FETCH_CHAT_USER_BADGE = 'FETCH_CHAT_USER_BADGE';
export const FETCH_CHAT_USER_BADGE_SUCCESS = 'FETCH_CHAT_USER_BADGE_SUCCESS';
export const FETCH_CHAT_TECHNICIAN_BADGE = 'FETCH_CHAT_TECHNICIAN_BADGE';
export const FETCH_CHAT_TECHNICIAN_BADGE_SUCCESS = 'FETCH_CHAT_TECHNICIAN_BADGE_SUCCESS';

